// Define Reducers for Calendar
import { createReducer } from "../../common/reduxUtil";
import {
  LOGIN_USER_REQUEST,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  LOGOUT_USER,
  UPDATE_PROFILE,
  UPDATE_EMAIL_VERIFICATION,
  SHOW_LOGIN_MODAL,
  REDIRECT_AFTER_LOGIN,
  SET_IS_PLATFORM_INVITE_LOADING,
  SET_PLATFORM_INVITE,
  UPDATE_GAMEPLAYER_PROFILE_KEYS,
  UPDATE_PROFILE_KEYS,
  SHOW_OAUTH_REGISTER_MODAL,
  CONTACT_INFO,
  AUTH_PROVIDER,
  UPDATE_TAG_LINE,
  SHOW_SHORTLIST_MODAL,
  SET_CRM_PROFILE,
} from "./types";

const initialState = {
  accessToken: null,
  isAuthenticated: false,
  isAuthenticating: false,
  authenticationStatusText: null,
  profile: {},
  gamePlayerProfile: {},
  provider: "",
  shouldRetry: false,
  showLoginModal: false,
  oAuthRegisterModal: false,
  redirectTo: null,
  loginPrompt: "",
  isLoginDismissible: false,
  onModalHideCallback: null,
  isPlatformInviteLoading: false,
  platformInvite: null,
  contactInfo: null,
  authProvider: null,
  preferredLoginMethod: null,
  isOpenShortListModal: false,
  crmProfile: null,
  crmProfileLoaded: false,
};

export default createReducer(initialState, {
  [SHOW_SHORTLIST_MODAL]: (state, payload) => {
    return Object.assign({}, state, {
      isOpenShortListModal: payload.value,
    });
  },
  [LOGIN_USER_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticating: true,
      authenticationStatusText: "Authenticating...",
      provider: payload.provider,
    });
  },
  [LOGIN_USER_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticating: false,
      isAuthenticated: true,
      accessToken: payload.accessToken,
      profile: payload.profile,
      authenticationStatusText: "You have been successfully logged in.",
      shouldRetry: false,
    });
  },
  [LOGIN_USER_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticating: false,
      isAuthenticated: false,
      accessToken: null,
      profile: {},
      authenticationStatusText: payload.authenticationStatusText,
      shouldRetry: true,
    });
  },
  [LOGOUT_USER]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticated: false,
      isAuthenticating: false,
      shouldRetry: false,
      accessToken: null,
      profile: {},
      authenticationStatusText: "You have been successfully logged out.",
      gamePlayerProfile: {},
      crmProfile: null,
      crmProfileLoaded: false,
    });
  },
  [UPDATE_PROFILE]: (state, payload) => {
    return Object.assign({}, state, {
      gamePlayerProfile: { ...state.gamePlayerProfile, ...payload.profile },
    });
  },
  [UPDATE_EMAIL_VERIFICATION]: (state, payload) => {
    return Object.assign({}, state, {
      profile: {
        ...state.profile,
        isEmailVerified: payload.isEmailVerified,
      },
    });
  },
  [SHOW_LOGIN_MODAL]: (state, payload) => {
    const newState = {
      showLoginModal: payload.value,
      loginPrompt: payload.loginPrompt ? payload.loginPrompt : "",
      isLoginDismissible: payload.isLoginDismissible ? true : false,
      onModalHideCallback: payload.onModalHideCallback,
      preferredLoginMethod: payload?.preferredLoginMethod,
    };

    if (payload.redirectTo) {
      newState["redirectTo"] = payload.redirectTo;
    }

    return Object.assign({}, state, { ...newState });
  },
  [REDIRECT_AFTER_LOGIN]: (state, payload) => {
    return Object.assign({}, state, {
      redirectTo: payload.value,
    });
  },
  [SET_IS_PLATFORM_INVITE_LOADING]: (state, payload) => {
    return Object.assign({}, state, {
      isPlatformInviteLoading: payload.value,
    });
  },
  [SET_PLATFORM_INVITE]: (state, payload) => {
    return Object.assign({}, state, {
      platformInvite: payload.value,
    });
  },
  [UPDATE_GAMEPLAYER_PROFILE_KEYS]: (state, payload) => {
    return Object.assign({}, state, {
      gamePlayerProfile: {
        ...state.gamePlayerProfile,
        ...payload,
      },
    });
  },
  [UPDATE_PROFILE_KEYS]: (state, payload) => {
    return Object.assign({}, state, {
      profile: {
        ...state.profile,
        ...payload,
      },
    });
  },
  [SHOW_OAUTH_REGISTER_MODAL]: (state, payload) => {
    return Object.assign({}, state, {
      oAuthRegisterModal: payload.value,
    });
  },
  [AUTH_PROVIDER]: (state, payload) => {
    return Object.assign({}, state, {
      authProvider: payload.value,
    });
  },
  [CONTACT_INFO]: (state, payload) => {
    return Object.assign({}, state, {
      contactInfo: payload.value,
    });
  },
  [UPDATE_TAG_LINE]: (state, payload) => {
    return Object.assign({}, state, {
      ...state,
      tagline: payload.tagline,
    });
  },
  [SET_CRM_PROFILE]: (state, payload) => {
    return Object.assign({}, state, {
      crmProfile: payload.crmProfile,
      crmProfileLoaded: true,
    });
  },
});
